const formatTimeFromApi = time => {
    if (!time || typeof time !== 'string') {
        return undefined;
    }

    if (time.includes('T')) {
        const timePart = time.split('T')[1] || '';
        return timePart.slice(0, 5) || undefined;
    }

    return time.length >= 5 ? time.slice(0, 5) : time;
};

export const mapAdvertisementToFormValues = (record, existingImageUrl) => {
    if (!record) {
        return {};
    }

    return {
        ...record,
        hourFrom: formatTimeFromApi(record.startTime),
        hourTo: formatTimeFromApi(record.endTime),
        advertisementImage: existingImageUrl ? { src: existingImageUrl } : undefined,
    };
};
